// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3470":"b229fbfb9cf6b0e5","6308":"36bab2a6365c0949","9122":"87f1fab4a30f03bf","9616":"b6cdf02ba36f010a"}[chunkId] + ".css";
};